import styled from 'styled-components';

const TextContainer = styled('div')`
    text-align: center;
`;

const NoTeamsText = () => {
    return (
        <TextContainer>
            <p>
                Your account is not associated with any FOVEA teams.
                If you have recently been added to a team, please refresh the page.
            </p>

            <p>
                If your company has a FOVEA team, please contact your team administrator
                to be added to the team.
            </p>

            <p>
                If your company does not have a FOVEA team and would like to
                get started, please contact <a href='mailto:support@archvision.com'>support@archvision.com</a>
            </p>
        </TextContainer>
    );
};

const NoAdminAccessText = () => {
    return (
        <TextContainer>
            <p>
                This page is for team administrators only.
            </p>
            <p>
                Please contact your team administrator to gain access to this page.
            </p>
        </TextContainer>
    );

};


export { NoTeamsText, NoAdminAccessText };
